import { Question, isColorQuestion, Colors, CardCategory, Card } from './store/game';
import _ from 'lodash';

export function getInformantCardLetter(index: number) {
    return String.fromCharCode(65 + index);
}

export function questionAsSentence(question: Question) {
    if (isColorQuestion(question)) {
        const color = Colors[question.color];
        return `quante carte di colore ${color} vede`;
    }
    let type = "";
    switch (question.category) {
        case CardCategory.Person:
            type = question.type == "A" ? "UOMINI" : "DONNE";
            break;
        case CardCategory.Location:
            type = question.type == "A" ? "LUOGHI INTERNI" : "LUOGHI ESTERNI";
            break;
        case CardCategory.Weapon:
            type = question.type == "A" ? "ARMI RAVVICINATE" : "ARMI A DISTANZA";
            break;
    }
    return `quante carte ${type} vede`;
}

export function getCardName(card: Card) {
    const persons = [
        "Ufficiale",
        "Duca",
        "Macellaio",
        "Contessa",
        "Infermiera",
        "Governante",
        "Ballerina",
        "Marinaio",
        "Fioraia",
        "Cocchiere"
    ],
        locations = [
            "Soggiorno",
            "Mercato",
            "Biblioteca",
            "Parco",
            "Museo",
            "Porto",
            "Teatro",
            "Piazza",
            "Vagone",
            "Ippodromo"
        ],
        weapons = [
            "Pugnale",
            "Balestra",
            "Veleno",
            "Spada",
            "Cerbottana",
            "Fucile",
            "Pistola",
            "Candelabro",
            "Martello",
            "Arco"
        ];

    switch (card.category) {
        case CardCategory.Person:
            return persons[card.number];
        case CardCategory.Location:
            return locations[card.number];
        case CardCategory.Weapon:
            return weapons[card.number];
    }
}

export function getCardFilename(card: Card) {
    let cat = "";
    switch (card.category) {
        case CardCategory.Person:
            cat = "p";
            break;
        case CardCategory.Location:
            cat = "l";
            break;
        case CardCategory.Weapon:
            cat = "a";
            break;
    }
    const number = _.padStart(card.number.toString(), 2, "0");
    return `${cat}${number}`;
}